module.exports = __webpack_public_path__ + "static/media/sharepointlook.d5b6cce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/sharepointlook.png
// module id = 843
// module chunks = 7